/**
 * Native apps load the hosted SPA from Netlify. Reload when a new deploy is detected.
 */
import { Capacitor } from '@capacitor/core';

const DEPLOY_ID_PATH = '/deploy-id.txt';

export function initNativeOtaRefresh(): void {
  if (!Capacitor.isNativePlatform()) return;

  let lastDeployId: string | null = null;

  const check = async () => {
    try {
      const res = await fetch(`${window.location.origin}${DEPLOY_ID_PATH}?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!res.ok) return;
      const id = (await res.text()).trim();
      if (!id) return;
      if (lastDeployId && id !== lastDeployId) {
        window.location.reload();
        return;
      }
      lastDeployId = id;
    } catch {
      /* offline — keep running cached bundle */
    }
  };

  void check();
  void import('@capacitor/app').then(({ App }) => {
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) void check();
    });
    App.addListener('resume', () => void check());
  });
}
